import { LinearGradient } from 'expo-linear-gradient';
import { router, Stack } from 'expo-router';
import { ArrowLeft, ArrowRight, Brain, Cards, ChatCircleDots, CurrencyEur, FileText, GraduationCap, ShieldCheck } from 'phosphor-react-native';
import { Image, ScrollView, Share, StyleSheet, TouchableOpacity, View } from 'react-native';
import { Text } from 'react-native-paper';

// Design System Colors
const colors = {
  indigo700: '#4F46E5',
  indigo600: '#6366F1',
  indigo500: '#818CF8',
  indigo400: '#A5B4FC',
  indigo100: '#E0E7FF',
  indigo50: '#EEF2FF',
  slate900: '#0F172A',
  slate800: '#1E293B',
  slate700: '#334155',
  slate600: '#475569',
  slate500: '#64748B',
  slate400: '#94A3B8',
  slate200: '#E2E8F0',
  slate100: '#F1F5F9',
  slate50: '#F8FAFC',
  white: '#FFFFFF',
  purple600: '#7C3AED',
  amber500: '#F59E0B',
  amber100: '#FEF3C7',
  emerald500: '#10B981',
  orange500: '#F97316',
};

const arguments_parents = [
  {
    icon: FileText,
    title: 'Création de fiches à partir de mes cours',
    color: colors.indigo600,
  },
  {
    icon: Brain,
    title: 'Coach disponible 24h/24 pour répondre à mes questions et m\'aider à comprendre',
    color: colors.purple600,
  },
  {
    icon: GraduationCap,
    title: 'Outils de révision complets : quiz, flashcards, fiches...',
    color: colors.amber500,
  },
];

export default function ConvinceParentsScreen() {
  const handleBack = () => {
    router.back();
  };

  const handleShare = async () => {
    try {
      await Share.share({
        message: `👋 Maman, Papa,

J'ai trouvé la meilleure application pour m'aider dans mes révisions : Ernest !

🐙 Ernest est un coach IA conçu par des enseignants qui m'aide dans toutes mes matières :

✅ Création de fiches à partir de mes cours
✅ Coach disponible 24h/24 pour répondre à mes questions et m'aider à comprendre
✅ Outils de révision complets : quiz, flashcards, fiches...

💰 Et l'abonnement coûte moins cher qu'1h de cours avec un prof particulier !

👉 Seulement 4,17€/mois avec l'abonnement annuel

Vous pouvez regarder l'app ici : https://ernest-app.fr

Merci ! ❤️`,
        title: 'Ernest - Application de révision',
      });
    } catch (error) {
      console.error('Error sharing:', error);
    }
  };

  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      
      <View style={styles.container}>
        {/* Header gradient comme Eliott */}
        <LinearGradient
          colors={[colors.indigo100, colors.slate50]}
          style={styles.headerGradient}
        >
          {/* Bouton Retour */}
          <TouchableOpacity 
            style={styles.backButton}
            onPress={handleBack}
            activeOpacity={0.7}
          >
            <ArrowLeft size={20} color={colors.slate700} weight="bold" />
            <Text style={styles.backButtonText}>Retour</Text>
          </TouchableOpacity>

          {/* Titre */}
          <View style={styles.headerContent}>
            <Text style={styles.headerTitle}>
              Besoin de convaincre tes parents ?
            </Text>
            <Text style={styles.headerTitleHighlight}>
              Partage leur ce screen !
            </Text>
            <Text style={styles.headerSubtitle}>
              Reviens à l'écran précédent{'\n'}pour prendre l'abonnement
            </Text>
          </View>
        </LinearGradient>

        <ScrollView 
          style={styles.scrollView}
          showsVerticalScrollIndicator={false}
          contentContainerStyle={styles.scrollContent}
        >
          {/* Carte Message Parents */}
          <View style={styles.messageCard}>
            {/* Header carte avec logo */}
            <View style={styles.messageHeader}>
              <Image 
                source={require('../assets/images/ernest.png')} 
                style={styles.messageLogo}
              />
              <Text style={styles.messageAppName}>ERNEST</Text>
            </View>

            {/* Corps du message */}
            <View style={styles.messageBody}>
              <Text style={styles.messageSalutation}>Maman, Papa,</Text>
              
              {/* ✅ Ajout mention "conçue par des enseignants" */}
              <Text style={styles.messageIntro}>
                J'ai trouvé la meilleure application pour m'aider dans mes révisions : <Text style={styles.messageHighlight}>Ernest</Text> !
              </Text>

              {/* Box arguments */}
              <View style={styles.argumentsBox}>
                <Text style={styles.argumentsTitle}>
                  Ernest est un coach IA <Text style={styles.teacherMention}>conçu par des enseignants</Text> qui m'aide dans{' '}
                  <Text style={styles.argumentsHighlight}>toutes mes matières</Text>
                </Text>

                {arguments_parents.map((arg, index) => {
                  return (
                    <View key={index} style={styles.argumentRow}>
                      <ArrowRight size={18} color={colors.indigo500} weight="bold" />
                      <Text style={styles.argumentText}>{arg.title}</Text>
                    </View>
                  );
                })}
              </View>

              {/* Argument prix */}
              <Text style={styles.priceArgument}>
                Et l'abonnement coûte moins cher{'\n'}
                <Text style={styles.priceHighlight}>qu'1h de cours avec un prof particulier !</Text>
              </Text>
            </View>

            {/* ✅ 4 icônes : Fiches, Quiz, Flashcards, Coach IA */}
            <View style={styles.screenshotsContainer}>
              <View style={styles.screenshotPlaceholder}>
                <FileText size={28} color={colors.indigo500} weight="duotone" />
                <Text style={styles.screenshotLabel}>Fiches</Text>
              </View>
              <View style={styles.screenshotPlaceholder}>
                <GraduationCap size={28} color={colors.amber500} weight="duotone" />
                <Text style={styles.screenshotLabel}>Quiz</Text>
              </View>
              <View style={styles.screenshotPlaceholder}>
                <Cards size={28} color={colors.orange500} weight="duotone" />
                <Text style={styles.screenshotLabel}>Flashcards</Text>
              </View>
              <View style={styles.screenshotPlaceholder}>
                <ChatCircleDots size={28} color={colors.purple600} weight="duotone" />
                <Text style={styles.screenshotLabel}>Coach IA</Text>
              </View>
            </View>
          </View>

          {/* Trust badges */}
          <View style={styles.trustBadges}>
            <View style={styles.trustBadge}>
              <ShieldCheck size={20} color={colors.emerald500} weight="duotone" />
              <Text style={styles.trustText}>Données sécurisées</Text>
            </View>
            <View style={styles.trustBadge}>
              <CurrencyEur size={20} color={colors.emerald500} weight="duotone" />
              <Text style={styles.trustText}>Annulable à tout moment</Text>
            </View>
          </View>

          {/* ✅ Espace suffisant pour voir les trust badges au-dessus du CTA */}
          <View style={{ height: 140 }} />
        </ScrollView>

        {/* CTA Fixe en bas */}
        <View style={styles.ctaContainer}>
          <TouchableOpacity
            style={styles.ctaButton}
            onPress={handleShare}
            activeOpacity={0.9}
          >
            <LinearGradient
              colors={[colors.slate800, colors.slate900]}
              style={styles.ctaButtonGradient}
            >
              <Text style={styles.ctaButtonText}>Partage à tes parents ! 📲</Text>
            </LinearGradient>
          </TouchableOpacity>
        </View>
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.slate50,
  },
  
  // Header Gradient
  headerGradient: {
    paddingTop: 56,
    paddingBottom: 24,
    paddingHorizontal: 20,
  },
  backButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    marginBottom: 20,
  },
  backButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: colors.slate700,
  },
  headerContent: {
    alignItems: 'center',
  },
  headerTitle: {
    fontSize: 26,
    fontWeight: '800',
    color: colors.slate900,
    textAlign: 'center',
    letterSpacing: -0.5,
  },
  headerTitleHighlight: {
    fontSize: 26,
    fontWeight: '800',
    color: colors.indigo600,
    textAlign: 'center',
    letterSpacing: -0.5,
    marginBottom: 12,
  },
  headerSubtitle: {
    fontSize: 15,
    color: colors.slate500,
    textAlign: 'center',
    lineHeight: 22,
  },

  // Scroll
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    paddingHorizontal: 20,
    paddingTop: 8,
  },

  // Message Card
  messageCard: {
    backgroundColor: colors.white,
    borderRadius: 24,
    padding: 20,
    shadowColor: colors.slate900,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 16,
    elevation: 4,
    marginBottom: 20,
  },
  messageHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    backgroundColor: colors.slate800,
    marginHorizontal: -20,
    marginTop: -20,
    paddingVertical: 14,
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    marginBottom: 20,
  },
  messageLogo: {
    width: 28,
    height: 28,
    resizeMode: 'contain',
  },
  messageAppName: {
    fontSize: 16,
    fontWeight: '800',
    color: colors.white,
    letterSpacing: 1,
  },
  messageBody: {
    gap: 16,
  },
  messageSalutation: {
    fontSize: 17,
    fontWeight: '700',
    color: colors.slate900,
  },
  messageIntro: {
    fontSize: 15,
    color: colors.slate700,
    lineHeight: 22,
  },
  messageHighlight: {
    fontWeight: '700',
    color: colors.indigo600,
  },

  // Arguments Box
  argumentsBox: {
    backgroundColor: colors.slate50,
    borderRadius: 16,
    padding: 16,
    gap: 12,
  },
  argumentsTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: colors.slate700,
    lineHeight: 20,
  },
  // ✅ Mention "conçu par des enseignants"
  teacherMention: {
    fontWeight: '600',
    color: colors.indigo600,
  },
  argumentsHighlight: {
    backgroundColor: colors.amber100,
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 4,
    overflow: 'hidden',
  },
  argumentRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 10,
  },
  argumentText: {
    flex: 1,
    fontSize: 14,
    color: colors.slate600,
    lineHeight: 20,
  },

  // Price Argument
  priceArgument: {
    fontSize: 15,
    color: colors.indigo600,
    textAlign: 'center',
    lineHeight: 22,
  },
  priceHighlight: {
    fontWeight: '700',
  },

  // ✅ 4 icônes (Fiches, Quiz, Flashcards, Coach IA)
  screenshotsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
    paddingHorizontal: 8,
  },
  screenshotPlaceholder: {
    width: 70,
    height: 70,
    backgroundColor: colors.slate50,
    borderRadius: 14,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
  },
  screenshotLabel: {
    fontSize: 10,
    fontWeight: '600',
    color: colors.slate500,
  },

  // Trust Badges
  trustBadges: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 20,
    marginBottom: 20,
  },
  trustBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  trustText: {
    fontSize: 13,
    color: colors.slate500,
    fontWeight: '500',
  },

  // ✅ CTA avec padding bottom augmenté
  ctaContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    paddingHorizontal: 20,
    paddingTop: 16,
    paddingBottom: 40,
    backgroundColor: colors.white,
    borderTopWidth: 1,
    borderTopColor: colors.slate100,
  },
  ctaButton: {
    borderRadius: 16,
    overflow: 'hidden',
    shadowColor: colors.slate900,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 12,
    elevation: 6,
  },
  ctaButtonGradient: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 18,
  },
  ctaButtonText: {
    color: colors.white,
    fontSize: 17,
    fontWeight: '700',
  },
});
